export class ContentSAT  {

    order: number;
    message: string;
    
    smsAction: SmsAction;
    browserAction:  BrowserAction;
    inputAction: InputAction;

}


export class BrowserAction  {

    loadingText: string;
    url: string;

} 


export class SmsAction  {

    to: string;
    content: string;

} 

export class InputAction  {

    max: number;
    min: number;
    short_code: string;

} 
